export const HOSPITAL_UNITS_OF_MEASURE = [
  'Piece',
  'Carton',
  'Box',
  'Pack',
  'Case',
  'Blister',
  'Tablet',
  'Capsule',
  'Bottle',
  'Vial',
  'Ampoule',
  'Syringe',
  'Tube',
  'Bag',
  'Kit',
  'Set',
  'Roll',
  'Pair',
  'Liter',
  'Milliliter',
  'Gallon',
  'Gram',
  'Kilogram',
  'Ton',
  'Milligram',
  'Microgram',
  'Dose',
  'Unit',
  'Strip',
  'Tray',
  'Canister',
];